import { DetailedApiMethod, FormApiMethod } from '../../../types/types';

// Resolves the correct apiMethod variant for a given form usecase
export const resolveFormApiMethod = (
  apiMethod: FormApiMethod,
  usecase:
    | 'create-item'
    | 'get-default-values'
    | 'get-item-values'
    | 'update-values'
    | 'delete-item'
): string | DetailedApiMethod | undefined => {
  if (usecase === 'create-item') {
    if (apiMethod.insert) {
      return apiMethod.insert;
    }
  }

  if (usecase === 'get-default-values') {
    if (apiMethod.default) {
      return apiMethod.default;
    }
  }

  if (usecase === 'get-item-values') {
    if (apiMethod.get) {
      return apiMethod.get;
    }
  }

  if (usecase === 'update-values') {
    if (apiMethod.update) {
      return apiMethod.update;
    }
  }

  return apiMethod.default;
};
